export enum AppwriteApiEndpoint {
    Ping = 'ping',
    CheckIfIAmClientDevice = 'check-if-i-am-client-device',
    CheckOnNetwork = 'check-on-network',

    CreateUser = 'create-user',
    CreateNonEmailUser = 'create-non-email-user',
    UpdateUser = 'update-user',
    UpdateNonEmailUser = 'update-non-email-user',
    DeactivateUser = 'deactivate-user',
    SetUserPassword = 'set-user-password',
    ResetPassword = 'reset-password',
    DeleteUser = 'delete-user',

    TranslateText = 'translate-text',
    ConvertStepToGltf = 'convert-file-to-gltf',

    QueryGrok = 'query-grok',
    QueryGrokVision = 'query-grok-vision',
    QueryGrokTts = 'query-grok-tts',
    LoadEmailGroups = 'load-email-groups',
    SendEmail = 'send-email',
    GenerateC3WeeklyInventoryReport = 'generate-weekly-inventory-report',
    SendTestC3WeeklyInventoryReport = 'send-test-weekly-inventory-report',
    SendScheduledC3WeeklyInventoryReport = 'send-scheduled-weekly-inventory-report',
    BatchSet = 'batch-set',

    CopyCollection = 'copy-collection',
    DeleteCollection = 'delete-collection',
    ListRootCollections = 'list-root-collections',
    CopyUserDataBetweenEnvironments = 'copy-user-data-between-environments',

    // Off-network label printing: the client falls back to this proxy endpoint (under the
    // utility route) which forwards { labelPrinterId, zpl } to onsite-utilities, which makes
    // the TCP connection to the printer as usual.
    PrintLabel = 'print-label',

    // UPS. UpsGetEnvironment is a credential-free health check that reports which
    // UPS host the running environment resolves to (CIE vs production), so the
    // test/prod switch can be verified before any real call. UpsGetAccessToken
    // performs the OAuth client-credentials handshake against that host.
    UpsGetEnvironment = 'ups-get-environment',
    UpsGetAccessToken = 'ups-get-access-token',
    UpsGetAccounts = 'ups-get-accounts',
    UpsCreateShipment = 'ups-create-shipment',
    UpsRateShipment = 'ups-rate-shipment',
    UpsVoidShipment = 'ups-void-shipment',
    UpsTrackShipment = 'ups-track-shipment',
}
